import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';

import CardView from './card-view.container';
// import CourseView from './courses.container';
import CourseView from './course-view'


const CustomTabs = withStyles(theme => ({
  root: {
    marginBottom: 10,
    // paddingBottom: -3,
    // borderBottom: '3px solid #e8e8e8',
  },
  indicator: {
    height: 3,
    backgroundColor: theme.palette.secondary.main,
  },
}))(Tabs);

const CustomTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fonzSize: 20,
    height: 30,
    fontWeight: 800,
    borderBottom: '3px solid #e8e8e8',
    color: 'grey',
    // marginRight: theme.spacing(4),
    '&:hover': {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    '&$selected': {
      color: theme.palette.primary.main,
      fontWeight: 800,
    },
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  selected: {},
}))(props => <Tab disableRipple {...props} />);

class BulletinBoard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabValue: 'courseTab',
      // tabValue: 'cardTab'
    };
  }

  componentWillReceiveProps({ bulletinBoard }) {
    if (bulletinBoard && this.props.bulletinBoard !== bulletinBoard) {
      this.props.getPinnedContentAction(bulletinBoard.id, {});
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  }

  renderView() {
    switch (this.state.tabValue) {
      case 'courseTab': return (<CourseView
        disableSearch
        match={this.props.match}
        location={this.props.location}
        history={this.props.history}
        bulletinBoard={this.props.bulletinBoard}
        getPinnedContentAction={this.props.getPinnedContentAction}
        courseUrl={'courses'}
      />);
      case 'cardTab': return (<CardView
        history={this.props.history}
        match={this.props.match}
        location={this.props.location}
        courseUrl={'courses'}
      />);
      default: return null;
    }
  }

  render() {
    return (
      <div>
        <CustomTabs onChange={this.handleTabChange} value={this.state.tabValue} style={{ marginBottom: 10 }}>
          <CustomTab label="Kurs" value="courseTab" />
          <CustomTab label="Kärtchen" value="cardTab" />
        </CustomTabs>
        {this.renderView()}
      </div>
    );
  }
}

export default BulletinBoard;



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/bulletin-board.js